<template>
  <div>
    <div 
      v-if="isReportEnabled('eventRegistrationMembershipReport')" 
      :class="['reportCard', organizationMembershipReportClass]" 
      @click="prepareOrgMembershipReport()"
    >
      <div class="cardImg"><i class="fal fa-table"></i></div>
      <div class="cardTitle">{{ $tc("page.report.organization-membership-report") }}</div><br>
      <div class="cardDesc">{{ $tc("page.report.organization-membership-description") }}</div>
    </div>
    <div class="clear"></div>

    <div 
      v-if="isReportEnabled('raceParticipantMembership')" 
      :class="['reportCard', raceParticipantMembership]" 
      @click="prepareRaceParticipantMembership()"
    >
      <div class="cardImg"><i class="fal fa-table"></i></div>
      <div class="cardTitle">{{ $tc("page.report.race-participant-membership") }}</div>
    </div>
    <div class="v-spacer"></div>

    <v-card v-if="displayTable" class="mx-auto" width="100%">
      <v-card-title v-if="membershipSetupReportClass == 'active'">{{ $tc("page.report.membership-setup-report") }}</v-card-title>
      <v-card-title v-if="raceParticipantMembership == 'active'">{{ $tc("page.report.race-participant-membership") }}</v-card-title>
      <v-card-title v-if="organizationMembershipReportClass == 'active'">{{ $tc("page.report.organization-membership-report") }}</v-card-title>
      
      <v-card-text class="text--primary">
        <v-container fluid>
          <v-row v-if="report == 'race-participant'">
            <v-col class="d-flex" cols="12" sm="6" >
              <v-autocomplete
                v-model="raceSelected"
                :items="racesItems"
                @change="getOrganizationsByRace()"
                item-text="text"
                item-value="id"
                dense
                outlined
                :label="$tc('page.report.label-event-memberships-select-race')"
                return-object
                hide-details
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="report == 'race-participant'">
            <v-col class="d-flex" cols="12" sm="6">
              <v-autocomplete
                v-model="orgRaceSelected"
                :items="orgRaceItems"
                item-text="text"
                item-value="id"
                dense
                outlined
                :label="$tc('page.report.label-event-memberships-select-organization')"
                return-object
                hide-details
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center"  v-if="report == 'participant' || report == 'setup-report' || report == 'organization-report'">
            <v-col class="d-flex" cols="12" sm="6">
              <v-autocomplete 
                v-if="report == 'participant'" 
                v-model="eventSelected" 
                :items="eventItems" 
                item-text="text" 
                item-value="id" 
                dense outlined 
                :label="$tc('page.report.label-event-memberships-select-event')" 
                return-object
              ></v-autocomplete>
              <v-autocomplete
                v-if="report == 'setup-report' || report == 'organization-report'"
                v-model="eventSelected"
                @change="
                  report == 'setup-report' ?
                    getMembershipReport({ eventId: eventSelected?.id, selfRegId: membershipSelected?.id }) :
                    getOrgMembershipReport({ eventId: eventSelected?.id, organizerId: membershipSelected?.organizerId, organizationId: membershipSelected?.id }, true)"
                :items="eventItems"
                item-text="text"
                item-value="id"
                dense
                outlined
                :label="$tc('page.report.label-event-memberships-select-event')"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center" v-if="report == 'participant' || report == 'setup-report'  || report == 'organization-report'">
            <v-col class="d-flex" cols="12" sm="6">
              <v-autocomplete
                v-if="report == 'participant'"
                v-model="participantRaceSelected"
                @change="getParticipantReport({ raceId: participantRaceSelected?.id })"
                :items="participantRaceItems"
                item-text="text"
                item-value="id"
                dense
                outlined
                :label="$tc('page.report.label-event-memberships-select-race')"
                return-object
              ></v-autocomplete>
              <v-autocomplete
                v-if="report == 'setup-report' || report == 'organization-report'"
                v-model="membershipSelected"
                @change="
                  report == 'setup-report' ?
                  getMembershipReport({ eventId: eventSelected?.id, selfRegId: membershipSelected?.id }) :
                  getOrgMembershipReport({ eventId: eventSelected?.id, organizerId: membershipSelected?.organizerId, organizationId: membershipSelected?.id })"
                :items="membershipItems"
                item-text="text"
                item-value="id"
                dense
                outlined
                :label="$tc('page.report.label-event-memberships-select-organization')"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card>
                <v-btn v-if="isShowButtons" color="blue-grey" class="ma-2 white--text" @click="downloadAsPDF()">
                  {{ $tc("page.report.label-pdf-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                </v-btn>
                <v-btn v-if="isShowButtons" color="blue-grey" class="ma-2 white--text" @click="downloadAsCSV()">
                  {{ $tc("page.report.label-csv-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                </v-btn>
                <v-btn color="blue-grey" class="ma-1 white--text" @click="refresh()">
                  {{ $tc("page.report.label-load-report-btn") }}
                  <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card style="width: 100%;">
                <VueTabulator v-if="report == 'participant'" ref="participantsTabulator" v-model="participantsTabulatorData" :options="participantsTabulatorOptions" class="table-striped table-bordered table-sm" />
                <VueTabulator v-if="report == 'setup-report'" ref="tabulator" v-model="tabulatorData" :options="tabulatorOptions" class="table-striped table-bordered table-sm" />
                <VueTabulator v-if="report == 'race-participant'" ref="tabulatorRaceParticipant" v-model="raceParticipantsTabulatorData" :options="tabulatorOptionsRP" class="table-striped table-bordered table-sm" />
                <VueTabulator v-if="report == 'organization-report'" ref="tabulatorOrganization" v-model="tabulatorOrgData" :options="tabulatorOrgOptions" class="table-striped table-bordered table-sm" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from 'vuex';
export default {
  mixins: [apiCalls],
  data() {
    return {
      eventSelected: {},
      eventItems: [],
      membershipSelected: {},
      membershipItems: [],
      raceSelected:{},
      racesItems:[],
      orgRaceSelected: {},
      orgRaceItems:[],
      search: "",
      tabulatorData: [],
      tabulatorOrgData: [],
      participantsTabulatorData: [],
      raceParticipantsTabulatorData: [],
      FilteredDataEventId: [],
      FilteredSelfRegId: [],
      displayTable: false,
      membershipSetupReportClass: "",
      raceParticipantMembership: "",
      organizationMembershipReportClass: "",
      participantRaceSelected: {},
      participantReportClass: "",
      participantRaceItems: [],
      report: "",
    };
  }, 
  computed: {
    participantsTabulatorOptions() {
      return {
        layout: "fitColumns",//"fitDataFill",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        //resizableColumns: false,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          //set the initial sort order of the data
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.label-event-memberships-firstName"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-lastName"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-mailingAddress"),
            field: "address",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("city", "participants"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("state", "participants"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-zipcode"),
            field: "zip",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 90,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-emailAddress"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 150,
            formatter: "textarea"
          },
        ],
      };
    },
    tabulatorOptions() {
      return {
        layout: "fitColumns",//"fitDataFill",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        //resizableColumns: false,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.label-event-memberships-firstName"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-lastName"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-emailAddress"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 120,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-createdDate"),
            field: "createdDate",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-orgName"),
            field: "promoterName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-memberId"),
            field: "memberId",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-dateTo"),
            field: "validTo",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
        ],
      };
    },
    tabulatorOrgOptions() {
      return {
        layout: "fitColumns",//"fitDataFill",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        //resizableColumns: false,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.label-event-memberships-firstName"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-lastName"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-emailAddress"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 150,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-createdDate"),
            field: "createdDate",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-className"),
            field: "className",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("className", "org"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-membershipType"),
            field: "Name",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-number"),
            field: "memberId",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-dateTo"),
            field: "validTo",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          }
        ],
      };
    }, 
    tabulatorOptionsRP() {
      return {
        layout: "fitColumns",//"fitDataFill",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        //resizableColumns: false,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        initialSort: [
          //set the initial sort order of the data
          {
            column: "firstName",
            dir: "asc",
          },
        ],
        columns: [
          {
            title: this.$t("page.report.label-event-memberships-firstName"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-lastName"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-emailAddress"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 150,
            formatter: "textarea"
          },
          {
            title: this.$t("common.table.name"),
            field: "name",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("name", "raceParticipants"),
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-memberId"),
            field: "memberId",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.label-event-memberships-dateTo"),
            field: "validTo",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            minWidth: 80,
            formatter: "textarea"
          },
        ],
      };
    },
    ...mapState({
      reportConfig: (state) => state.reports.reportConfig
    }),
    isShowButtons() {
      return (
        (this.report == 'setup-report' && (this.tabulatorData?.length || 0) > 0) || 
        (this.report == 'participant' && (this.participantsTabulatorData?.length || 0) > 0) ||
        (this.report == 'race-participant' && (this.raceParticipantsTabulatorData?.length || 0) > 0) || 
        (this.report == 'organization-report' && (this.tabulatorOrgData?.length || 0) > 0)
      );
    }
  },
  methods: {
    normalizeCaseValue(value) {
      return (value ?? "")
        .toString()
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    },
    getCaseInsensitiveMultiselectFilter(field, source = "participants") {
      return {
        headerFilterFunc: (headerValue, rowValue) => {
          const selectedValues = Array.isArray(headerValue) ? headerValue : (headerValue ? [headerValue] : []);
          if (!selectedValues.length) return true;
          const normalizedRowValue = this.normalizeCaseValue(rowValue);
          return selectedValues.map((value) => this.normalizeCaseValue(value)).includes(normalizedRowValue);
        },
        headerFilterParams: {
          values: () => {
            const sourceMap = {
              participants: this.participantsTabulatorData,
              raceParticipants: this.raceParticipantsTabulatorData,
              org: this.tabulatorOrgData,
            };
            const tableData = sourceMap[source] || [];
            const unique = new Set();
            tableData.forEach((row) => {
              const normalized = this.normalizeCaseValue(row?.[field]);
              if (normalized) unique.add(normalized);
            });
            return Array.from(unique).sort();
          },
          sortValuesList: "asc",
          multiselect: true
        }
      };
    },
    refresh() {
      if (this.report == "setup-report") {
        this.getMembershipReport({
          eventId: this.eventSelected.id,
          selfRegId: this.membershipSelected.id,
        });
      } else if( this.report == "participant") {
        this.getParticipantReport({
          raceId: this.participantRaceSelected?.id,
        });
      } else if( this.report == "race-participant" ){
        this.getRaceParticipantReport(false, true);
      } else {
        const item = this.membershipItems.find((el) => {
          return el.organizerId == this.membershipSelected?.id;
        });
        this.getOrgMembershipReport({
          eventId: this.eventSelected?.id,
          organizerId: item ? item.organizerId : this.membershipSelected?.organizerId,
          organizationId: item ? item.id : this.membershipSelected?.id
        }, false, true);
      }
    },
    async getParticipantReportEvents() {
      this.report = "participant";

      this.membershipSetupReportClass = "";

      if(this.participantReportClass == "active"){
        this.participantReportClass = "";
        this.displayTable = false;
      } else {
        this.participantReportClass = "active";
        this.displayTable = true;
      }

      const response = await this.api("get", "/api/v1/promoter/event/hasraces");

      this.eventItems = [
        {
        id: "-1",
        text: this.$t("common.form.select-an-option"),
          disabled: true
    },
        ...response.map(event => ({
          id: event.id,
          text: this.$escapeHtml.decode(event.eventName)
        }))
      ];
    },
    async getOrganizationsByRace(){
      if(!this.raceSelected?.eventId) return;
      let data = {
        report:"eventSelfReg",
        filter:{"eventId":this.raceSelected.eventId}
      }
      const response = await this.api("post", "/api/v1/promoter/reports/events/memberships", data);

      //select for events
      this.eventItems = response.filters[0].filter.data.map((el) => {
        return {
          ...el,
          text: this.$escapeHtml.decode(el.text)
        };
      });

      //select for memberships
      this.orgRaceItems = response.filters[1].filter.data.map((item) => {
        const replaceText = this.$t("page.report.label-event-memberships-select-organization-item-text")
          .replace("{_ORG_}", item.text);
        return {
          ...item,
          text: this.$escapeHtml.decode(replaceText)
        };
      });
      
        this.orgRaceSelected = null;
    },
    async getParticipantRacesReportRaces() {

      const response = await this.api("get", "/api/v1/users/current");
        const { success, message } = response;
        if (success) {
            this.user = message;
            const response1 = await this.api("get", `/api/v1/promoter/race/${this.user.id}`);
            const success1 = response1.success;
            const message1 = response1.message;
            if(success1) {
                this.racesItems = message1.map((item) => {
                    return {
                        id: item.raceId,
                        eventId: item.eventId,
                        text: `${item.eventDate} :: ${this.$escapeHtml.decode(item.eventName)} :: ${this.$escapeHtml.decode(item.raceName)}`
                    };
                });
            }
        }
    },
    async getParticipantReportRaces(data) {
      if(!data?.eventId) return;
      
      const response = await this.api("get", `/api/v1/promoter/event/${data.eventId}/races`);

      this.participantRaceItems = [
        {
        id: "-1",
        text: this.$t("common.form.select-an-option"),
    },
        ...response.map(race => ({
          id: race.id,
          text: this.$escapeHtml.decode(race.raceName),
        }))
      ];
    },
    async getRaceParticipantReport(){
      if(!this.raceSelected?.id || !this.orgRaceSelected?.organizerId) {
        let msgAlert = '';
        if(!this.raceSelected?.id) {
          msgAlert = this.$t('page.report.notifications.select-race-required');
        } else if(!this.orgRaceSelected?.organizerId) {
          msgAlert = this.$t('page.report.notifications.select-organization-required');
        }
        this.$store.commit('reports/SET_MSG_ALERT', msgAlert);
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }
      
      const response = await this.api("get", `/api/v1/promoter/reports/events/race/${this.raceSelected.id}/participant/`+this.orgRaceSelected.organizerId);
      this.raceParticipantsTabulatorData = response;
    },
    async getParticipantReport(data) {
      const response = await this.api("get", `/api/v1/promoter/reports/events/race/${data.raceId}/participant`);
      this.participantsTabulatorData = response;
    },
    async prepareRaceParticipantMembership(){
      this.membershipSetupReportClass = this.organizationMembershipReportClass = "";
      this.report = 'race-participant';

      if(this.raceParticipantMembership == "active"){
        this.raceParticipantMembership = "";
        this.displayTable = false;
      } else {
        this.raceParticipantMembership = "active";
        this.displayTable = true;
      }
      this.getParticipantRacesReportRaces();
    },
    async prepareMembershipReport(filter = null) {
      this.raceParticipantMembership = this.organizationMembershipReportClass = "";
      this.report = "setup-report";

      if(this.membershipSetupReportClass == "active"){
        this.membershipSetupReportClass = "";
        this.displayTable = false;
      } else {
        this.membershipSetupReportClass = "active";
        this.displayTable = true;
      }

      let data = {};
      data.report = "eventSelfReg";

      if (filter != null) {
        data.filter = filter;
      }

      const response = await this.api("post", "/api/v1/promoter/reports/events/memberships", data);

      //select for events
      this.eventItems = response.filters[0].filter.data.map((el) => {
        return {
          ...el,
          text: this.$escapeHtml.decode(el.text)
        };
      });

      response.filters[1].filter.data.forEach(
        function (e, i) {
          let replaceText = this.$t("page.report.label-event-memberships-select-organization-item-text").replace("{_ORG_}", response.filters[1].filter.data[i].text);
          response.filters[1].filter.data[i].text = replaceText;
        }.bind(this)
      );

      //select for memberships
      this.membershipItems = response.filters[1].filter.dat;
    },
    async prepareOrgMembershipReport() {
      this.raceParticipantMembership = this.membershipSetupReportClass = "";
      this.report = "organization-report";

      if(this.organizationMembershipReportClass == "active"){
        this.organizationMembershipReportClass = "";
        this.displayTable = false;
      } else {
        this.organizationMembershipReportClass = "active";
        this.displayTable = true;
      }
      this.getOrgMembershipReport();
    },
    async getMembershipReport(filter = null, isChangeEvent = false, isShowReport = false) {
      this.participantReportClass = "";
      this.membershipSetupReportClass = "active";
      this.report = "setup-report";

      let data = {};
      data.report = "eventSelfReg";

      const isEmptyFilter = !filter || 
                           filter == null || 
                           (typeof filter === 'object' && Object.keys(filter).length === 0) ||
                           (typeof filter === 'object' && Object.values(filter).every(value => value === undefined));

      if (!isEmptyFilter) {
        data.filter = filter;
      }

      const response = await this.api("post", "/api/v1/promoter/reports/events/memberships", data);

      //select for events
      this.eventItems = response.filters[0].filter.data.map((el) => {
        return {
          ...el,
          text: this.$escapeHtml.decode(el.text)
        };
      });

      response.filters[1].filter.data.forEach(
        function (e, i) {
          let replaceText = this.$t("page.report.label-event-memberships-select-organization-item-text").replace("{_ORG_}", response.filters[1].filter.data[i].text);
          response.filters[1].filter.data[i].text = replaceText;
        }.bind(this)
      );

      //select for memberships
      this.membershipItems = response.filters[1].filter.data;

      if(isChangeEvent){
        this.membershipSelected = undefined;
      }
      //the table data
      if(isShowReport) {
        this.tabulatorData = isEmptyFilter ? [] : response.results;
      }

      this.displayTable = true;
    },
    async getOrgMembershipReport(filter = null, isChangeEvent = false, isShowReport = false) {
      this.participantReportClass = this.membershipSetupReportClass = "";
      this.organizationMembershipReportClass = "active";
      this.report = "organization-report";

      let data = {};
      const isEmptyFilter = !filter || 
                            filter == null || 
                            (typeof filter === 'object' && Object.keys(filter).length === 0) || 
                            (typeof filter === 'object' && Object.values(filter).every(value => value === undefined));
      if (!isEmptyFilter) {
        data.filter = filter;
      }

      if(isShowReport && (!this.eventSelected?.id || !this.membershipSelected?.id)){
        let msgAlert = '';
        if(!this.eventSelected?.id) {
          msgAlert = this.$t('page.report.notifications.select-event-required');
        } else if(!this.membershipSelected?.id) {
          msgAlert = this.$t('page.report.notifications.select-organization-required');
        }
        this.$store.commit('reports/SET_MSG_ALERT', msgAlert);
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      let response = await this.api("post", "/api/v1/promoter/reports/events/membershipTypes", data);

      //select for events
      this.eventItems = response.filters[0].filter.data.map((el) => {
        return {
          ...el,
          text: this.$escapeHtml.decode(el.text)
        };
      });

      if(isChangeEvent){
      this.membershipItems = response.filters[1].filter.data.map((item) => {
        const replaceText = this.$t("page.report.label-event-memberships-select-organization-item-text")
          .replace("{_ORG_}", item.text);
        return {
          ...item,
          text: this.$escapeHtml.decode(replaceText)
        };
      });
        this.membershipSelected = undefined;
      }
      //the table data
      if(filter == null) {
        data.filter = { eventId: this.eventSelected?.id, organizerId: this.membershipSelected?.organizerId, organizationId: this.membershipSelected?.id};
        response = await this.api("post", "/api/v1/promoter/reports/events/membershipTypes", data);
      }

      if(isShowReport) {
        this.tabulatorOrgData = isEmptyFilter ? [] : response.results;
      }

      this.displayTable = true;
    },
    downloadAsPDF() {
      let tabulatorInstance;
      if (this.report == "participant") {
        tabulatorInstance = this.$refs.participantsTabulator.getInstance();
      } else if(this.report == "setup-report") {
        tabulatorInstance = this.$refs.tabulator.getInstance();
      }else if(this.report == "race-participant") {
        tabulatorInstance = this.$refs.tabulatorRaceParticipant.getInstance();
      } else {
        tabulatorInstance = this.$refs.tabulatorOrganization.getInstance();
      }
      tabulatorInstance.downloadToTab("pdf");
    },
    downloadAsCSV() {
      let tabulatorInstance;
      if (this.report == "participant") {
        tabulatorInstance = this.$refs.participantsTabulator.getInstance();
      } else if(this.report == "setup-report") {
        tabulatorInstance = this.$refs.tabulator.getInstance();
      }else if(this.report == "race-participant") {
        tabulatorInstance = this.$refs.tabulatorRaceParticipant.getInstance();
      } else {
        tabulatorInstance = this.$refs.tabulatorOrganization.getInstance();
      }
      tabulatorInstance.download("csv", "data.csv", {
        delimiter: ",",
      });
    },
    isReportEnabled(reportId) {
      return this.reportConfig.membership.reports.find(report => report.name === reportId && report.isEnabled) || false;
    },
    getSelectOrgMembershipReport() {
      if(this.report == 'setup-report') {
        this.getMembershipReport({ 
          eventId: this.eventSelected.id, 
          selfRegId: this.membershipSelected.id 
        }, true);
      } else {
        this.getOrgMembershipReport({ 
          eventId: this.eventSelected.id, 
          organizerId: this.membershipSelected.organizerId, 
          organizationId: this.membershipSelected.id 
        }, true);
    }
    }
                
  },
  created() {},
  mounted() {},
};
</script>

<style scoped>
.reportCard.active {
  background-color: var(--v-primary-base);
  color: var(--v-lighten-base);
  cursor: auto;
}

.reportCard {
  border: 1px var(--v-primary-darken2) solid;
  padding: 5px 0;
  cursor: pointer;
}

.reportCard .cardImg {
  float: left;
  font-size: 45px;
  width: 50px;
  height: 50px;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard > div > i {
  vertical-align: top;
}

.fal,
.far {
  font-family: "Font Awesome 5 Pro";
}

.fal {
  font-weight: 300;
}

.fa,
.fab,
.fad,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard .cardDesc {
  width: 80%;
  font-size:0.8em;
}

/*.v-card__title {
  background-color: #ddd;
  color: #333;
}*/

.reportCard {
  text-align: left;
}

.pdl8 {
  padding-left: 8px;
}
</style>
